export default __webpack_public_path__ + "static/media/kenal.d84bb7ed.png";